<template>
  <v-sheet height="100%">
    <slide4 />
    <v-dialog v-model="modalBoolean" width="85%">
      <v-card>
        <v-toolbar dark color="primary" :fixed="true">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="modalBoolean = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-img
                v-for="asset in clickedItem.assets"
                :key="asset"
                :src="renderImage(asset)"
                eager
              >
              </v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import slide4 from "../../public/static/Slide 4/EnvironmentalImpacts.svg";
import svgMixin from "@/mixins/svgMixin.js";

export default {
  name: "EnvironmentalImpacts",
  components: {
    slide4
  },
  mixins: [svgMixin(4, ".slide4", "slide4.js")],
  data() {
    return {
      modalBoolean: false,
      clickedItem: ""
    };
  },
  methods: {
    closeModal() {
      this.currentStation = null;
    }
  }
};
</script>
<style>
.mouse {
  cursor: pointer;
}
</style>
